import range from 'lodash/range';
import React, { Component } from 'react';
import {PAGINATION_LIST_SIZE, USER, USER_ROLES} from '../../../helpers/constants';
import { Alert, Button, Card, CardBody, CardTitle } from 'reactstrap';
import translate from '../../../helpers/LanguageModel';
import {closeAlert} from '../../../actions/commonsActions';
import {push} from "connected-react-router";
import {fetchCompanies} from '../../../actions/companyActions';
import {getRetailPackageList} from '../../../actions/retailActions';
import {connect} from 'react-redux';
import PackageAppList from '../PackageAppList/PackageAppList';
import QrCodeModal from '../QrCodeModal/QrCodeModal';


class PersonPackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            paginatedList: [],
            name: '',
            packageId: null,
            package: null,
            isQrModalShown: false
        };
    }

    componentDidMount() {
        const packageId = this.props.match && this.props.match.params && this.props.match.params.packageId ?
            this.props.match.params.packageId : null;
        if (this.props.authority === USER) {
            (async () => {
                try {
                    if (!this.props.companies[0]) {
                        await this.props.fetchCompanies();
                    }
                    await this.props.getRetailPackageList({
                        packageId,
                        page: 0
                    });
                } catch(error) {
                    console.log(error);
                }
                this.setState({
                    paginatedList: this.props.pagination.totalPages > PAGINATION_LIST_SIZE ?
                        range(0, PAGINATION_LIST_SIZE) : range(0, this.props.pagination.totalPages),
                    packageId,
                    package: this.props.packageApps.length ? (
                        this.props.packageApps[0].bundles.filter(bundle => bundle.id === +packageId)[0]
                    ) : []
                })
            })();
        }
    }

    fetchPaginatedData = currentPage => {
        this.props.getRetailPackageList({
            packageId: this.state.packageId,
            page: currentPage,
        });
    };

    setCurrentPage = currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage);
        });
    };

    setPaginatedList = paginatedList => {
        this.setState({
            paginatedList
        })
    };

    toggleQrModal = () => {
        this.setState({
            isQrModalShown: !this.state.isQrModalShown
        });
    }

    render() {
        const {lang, loading, packageApps, pagination } = this.props;
        const appList = loading ? <div className="loading">Loading...</div> :
            <PackageAppList
                lang={lang}
                data={packageApps}
                currentPage={this.state.currentPage}
                setCurrentPage={this.setCurrentPage}
                paginatedList={this.state.paginatedList}
                totalPages={pagination.totalPages}
                setPaginatedList={this.setPaginatedList}
                changeLocation={this.props.changeLocation}
            />
        return (
            <div className="personPackage">
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <QrCodeModal
                    isQrModalShown={this.state.isQrModalShown}
                    toggle={this.toggleQrModal}
                    package={this.state.package}
                />
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>
                            {this.state.package ? this.state.package.name : null}
                        </div>
                        <Button
                            color="primary"
                            type="button"
                            className="company-btn btn-clear"
                            onClick={()=> this.toggleQrModal()}
                        >
                            {translate('GENERATE_QR_CODE')}
                        </Button>
                    </CardTitle>
                    <CardBody>
                        {appList}
                    </CardBody>
                </Card>
            </div>
        )
    }
};

const mapDispatchToProps = dispatch => {
    return {
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: (url) => dispatch(push(url)),
        fetchCompanies: (query) => dispatch(fetchCompanies(query)),
        getRetailPackageList: (query) => dispatch(getRetailPackageList(query))
    };
};

const mapStateToProps = state => ({
    packageApps: state.retailPackageAppsList.packageApps,
    pagination: state.retailPackageAppsList.pagination,
    loading: state.retailPackageAppsList.loading,
    authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    currentUser: state.currentUser,
    companies: state.companiesReducer.companies,
    lang: state.languageReducer.lang,
    alert: state.alert
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonPackage)



// WEBPACK FOOTER //
// ./src/components/Person/PersonPackage/PersonPackage.js